export default __webpack_public_path__ + "static/testimonial-video-b742a4a3c64538bed8e374d723e586bb.svg";